
















































import { Vue, Component } from "vue-property-decorator";

import Modal from "@/components/Modal.vue";

@Component({
  components: {
    Modal
  },
  computed: {
    // https://vuex.vuejs.org/ja/guide/forms.html
    webhookMethod: {
      get() {
        return this.$store.state.webhook.method;
      },
      set(value) {
        this.$store.dispatch("updateWebhookMethod", value);
      }
    },
    webhookUrl: {
      get() {
        return this.$store.state.webhook.url;
      },
      set(value) {
        this.$store.dispatch("updateWebhookUrl", value);
      }
    },
    webhookHeaders: {
      get() {
        return this.$store.state.webhook.headers;
      },
      set(value) {
        this.$store.dispatch("updateWebhookHeaders", value);
      }
    },
    webhookData: {
      get() {
        return this.$store.state.webhook.data;
      },
      set(value) {
        this.$store.dispatch("updateWebhookData", value);
      }
    }
  }
})
export default class Webhook extends Vue {
  private isShown = false;
  private submitType: "try" | "save" = "try";
  private success = false;
  private successMessage = "";
  private errors: Array<string> = [];
  private webhookMethod!: "POST" | "PUT";
  private webhookUrl!: string;
  private webhookHeaders!: string;
  private webhookData!: string;

  private show() {
    this.$ga.event("menu", "click", "webhook");
    this.isShown = true;
  }

  private changeSubmitType(submitType: "try" | "save") {
    this.submitType = submitType;
  }

  private onSubmit() {
    switch (this.submitType) {
      case "try":
        this.tryRequest();
        break;
      case "save":
        this.save();
        break;
      default:
        break;
    }
  }

  private reset() {
    if (!window.confirm("Do you really want to reset?")) {
      return;
    }
    this.$store.dispatch("resetWebhookSettings");
  }

  private async tryRequest(): Promise<boolean> {
    this.errors = [];

    if (!this.webhookMethod) {
      this.errors.push("Method required.");
    } else {
      if (!/^(POST|PUT)$/.test(this.webhookMethod)) {
        this.errors.push("Invalid Method.");
      }
    }

    if (!this.webhookUrl) {
      this.errors.push("URL required.");
    } else {
      if (!/^(https?:\/\/)(\w)+/.test(this.webhookUrl)) {
        this.errors.push("Invalid URL.");
      }
    }

    if (this.webhookHeaders) {
      try {
        JSON.parse(this.webhookHeaders);
      } catch (err) {
        this.errors.push("Invalid headers.");
      }
    }

    if (this.webhookData) {
      try {
        JSON.parse(this.webhookData);
      } catch (err) {
        this.errors.push("Invalid data.");
      }
    }

    if (this.errors.length) {
      return false;
    }

    try {
      await this.$store.dispatch("tryWebhook", {
        url: this.webhookUrl,
        method: this.webhookMethod,
        headers: this.webhookHeaders,
        data: this.webhookData
      });
      this.success = true;
      this.successMessage = "webhook request suucessed.";
    } catch (err) {
      this.success = false;
      this.errors.push(`Request Invalid: ${err.message}`);
    }

    if (this.errors.length) {
      return false;
    }

    this.errors = [];
    return true;
  }

  private async save() {
    if (await this.tryRequest()) {
      this.$store.dispatch("saveWebhookSettings", {
        url: this.webhookUrl,
        method: this.webhookMethod,
        headers: this.webhookHeaders,
        data: this.webhookData
      });
      this.successMessage = "webhook setting saved.";
    }
  }
}
